import { render, staticRenderFns } from "./yddzqdkhfwxy2.vue?vue&type=template&id=37ae7960&scoped=true"
import script from "./yddzqdkhfwxy2.vue?vue&type=script&lang=js"
export * from "./yddzqdkhfwxy2.vue?vue&type=script&lang=js"
import style0 from "./yddzqdkhfwxy2.vue?vue&type=style&index=0&id=37ae7960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae7960",
  null
  
)

export default component.exports